import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { ExperimentAssetBrowser } from '../';

import './PickExperimentWinner.scss';

class PickExperimentWinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollToTop: false,
      selectedRow: [],
      initialized: false,
      sortColumn: this.props.experiment.sortColumn || {
        property: 'ctor',
        sortDirection: 'desc'
      }
    };
    this.typingTimer = null;
    this.isPaging = false;
  }

  componentDidMount() {
    const assets = this.rows();
    if (assets.length > 0 && this.state.selectedRow.length === 0) {
      // Select the first asset by default
      const selectedRow = assets.length ? assets[0] : null;
      this.setState({ selectedRow: [assets[0]] });
      this.props.actions.updateModal('endExperiment', { selectedRow });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'this.props.experiment.sortColumn'
      )
    ) {
    }
  }

  handleRowSelect(selection) {
    const selectedRow = selection.length ? selection[0] : null;
    this.setState({ selectedRow: selection });
    this.props.actions.updateModal('endExperiment', { selectedRow });
  }

  handleScrollToTop() {
    this.setState({ scrollToTop: false });
  }

  handleSort(sort) {
    this.setState({ sortColumn: { ...sort } });
    this.props.actions.updateModal('endExperiment', {
      sortColumn: this.state.sortColumn
    });
    this.sortAssets();
  }

  sortAssets() {
    const assets = this.props.experiment.content_test_assets;
    let sortedAssets;

    if (this.state.sortColumn.property === 'ctor') {
      if (this.state.sortColumn.sortDirection === 'desc') {
        sortedAssets = assets.sort(
          (a, b) => b.clicks / b.selections - a.clicks / a.selections
        );
      } else if (this.state.sortColumn.sortDirection === 'asc') {
        sortedAssets = assets.sort(
          (a, b) => a.clicks / a.selections - b.clicks / b.selections
        );
      }
    }
    return sortedAssets;
  }

  rows() {
    const context = this.props.context;
    if (context) {
      const assets = this.sortAssets() || [];
      if (this.props.experiment?.suggested_winner) {
        let asset = assets.find(
          asset => asset.uuid === this.props.experiment.suggested_winner
        );
        if (asset) {
          asset.isPredictedWinner = true;
        }
      }
      if (this.state.selectedRow?.length) {
        const selection = assets.find(
          asset => asset.uuid === this.state.selectedRow[0].uuid
        );
        if (!selection) {
          assets.unshift(this.state.selectedRow[0]);
        }
      }
      return assets;
    }
    return [];
  }

  render() {
    const columns = [
      { name: 'thumbnail', sortable: false, width: '62px' },
      { name: 'name', sortable: false },
      { name: 'clicks', sortable: false },
      {
        name: 'ctor',
        sortable: false,
        sortDirection: this.state.sortColumn.sortDirection
      }
    ];

    return (
      <div className="assetpicker">
        <ExperimentAssetBrowser
          selection={this.state.selectedRow}
          rowSelectionMode="radio"
          onRowSelect={(evt, { selection }) => this.handleRowSelect(selection)}
          columns={columns}
          assets={this.rows()}
          onScrollToTop={() => this.handleScrollToTop()}
          scrollToTop={this.state.scrollToTop}
          sortable
          onSort={sort => this.handleSort(sort)}
          sortColumn={this.state.sortColumn}
        />
      </div>
    );
  }
}

PickExperimentWinner.propTypes = {
  actions: PropTypes.object.isRequired,
  experiment: PropTypes.object.isRequired,
  initialSelection: PropTypes.string,
  onRowSelect: PropTypes.func,
  context: PropTypes.string,
  selectable: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(PickExperimentWinner);
